import {BaseAnalyticsService} from 'app/services/analytics.services/analytics.service';
import {CurrentUser} from 'app/classes';
import {Singleton} from 'app/utils';

export class Analytics {

    private registeredServices: Array<BaseAnalyticsService> = [];

    public registerService = (service: BaseAnalyticsService) => {
        this.registeredServices.push(service);
    };

    public registerServices(analyticsServices: Array<BaseAnalyticsService>) {
        analyticsServices.forEach(this.registerService);
    }

    public initServices() {
        this.registeredServices.forEach((service) => {
            service.init();
        });
    }

    public setUser(user: CurrentUser) {
        this.registeredServices.forEach((service) => {
            service.setUser(user);
        });
    }

    public sendEvent(event: string, metaData?: any) {
        this.registeredServices.forEach((service) => {
            service.sendEvent(event, metaData);
        });
    }

    public destroy() {
        this.registeredServices.forEach((service) => {
            service.destroy();
        });
    }
}

export let $Analytics = Singleton('$Analytics', Analytics);
